import React, { Component } from 'react'

class IcRightArrow extends Component {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <g fill="#FFF" fillRule="evenodd">
          <path
            fillOpacity=".2"
            fillRule="nonzero"
            d="M11.916 0C5.346 0 0 5.346 0 11.916s5.346 11.917 11.916 11.917 11.917-5.346 11.917-11.917C23.833 5.346 18.488 0 11.916 0z"
          />
          <path d="M17.232 9.19c.006.117.009.236.009.355 0 3.625-2.758 7.803-7.805 7.803a7.758 7.758 0 0 1-4.204-1.232 5.505 5.505 0 0 0 4.06-1.136 2.745 2.745 0 0 1-2.561-1.904 2.765 2.765 0 0 0 1.238-.046 2.743 2.743 0 0 1-2.2-2.69v-.034c.37.205.793.328 1.242.342a2.74 2.74 0 0 1-.848-3.662 7.788 7.788 0 0 0 5.653 2.867 2.743 2.743 0 0 1 4.674-2.502 5.475 5.475 0 0 0 1.742-.666 2.755 2.755 0 0 1-1.208 1.518A5.453 5.453 0 0 0 18.6 7.77a5.517 5.517 0 0 1-1.368 1.418z" />
        </g>
      </svg>
    )
  }
}

export default IcRightArrow
